module.exports = __webpack_public_path__ + "static/media/laundry_bundle_hero.462d726d.png";